module.exports = __webpack_public_path__ + "img/exchange-1-m.d29c7438.png";